export const manifestLocales = {
  submitPageTitle: {
    previewImageAlt: {
      en: 'Submit page title',
      he: 'סיכום והגשה: כותרת'
    }
  }
};
